import React from 'react';
import './timeBoxCard.css';

const TimeSlotCard = ({ time, type = "Clásico 60 Min" ,selected, onClick }) => (
    <div
      className={`time-slot-card ${selected ? 'selected' : ''}`}
      onClick={onClick}
    >
    <div className="time">{time}</div>
    <div className="details">
      <img src="/images/logos/icon-blue.png" alt="Fit Instinct" className="logo" />
      <span className="type">{type}</span>
    </div>
  </div>
);

export default TimeSlotCard;